import AlertsBar from "./AlertsBar/AlertsBar";
import "./BergEventLED.css";
import OpenHoursSimple from "./OpenHoursSimple/OpenHoursSimple";
import WeatherTileComponent from "./WeatherTile/WeatherTile";
const lg = require("../assets/logos/lg.png");
const kotelnica = require("../assets/logos/kotlenica.png");
const zebra = require("../assets/logos/zebra.png");
const hikvision = require("../assets/logos/hikvision.png");
const bergRegions = require("../assets/logos/bergRegions.png");
const hellobot = require("../assets/logos/hellobot.png");
const eService = require("../assets/logos/eService.png");

const BergEventLED = () => {
  const partners = [
    { id: 1, name: "Kotelnica", logo: kotelnica },
    { id: 2, name: "Zebra", logo: zebra },
    { id: 3, name: "Hikvision", logo: hikvision },
    { id: 4, name: "Berg Regions", logo: bergRegions },
    { id: 5, name: "LG", logo: lg },
    { id: 6, name: "Hellobot", logo: hellobot },
    { id: 7, name: "e-Service", logo: eService },
    //duplikaty
    { id: 8, name: "Kotelnica", logo: kotelnica },
    { id: 9, name: "Zebra", logo: zebra },
    { id: 10, name: "Hikvision", logo: hikvision },
    { id: 11, name: "Berg Regions", logo: bergRegions },
    { id: 12, name: "LG", logo: lg },
    { id: 13, name: "Hellobot", logo: hellobot },
    { id: 14, name: "e-Service", logo: eService },
  ];

  return (
    <div className="berg-led-display flex flex-col gap-1">
      <div className="flex flex-row gap-4 w-full mt-2 justify-center">
        <div className="section weather-section">
          <WeatherTileComponent />
        </div>

        <div className="section partners-section">
          <div className="partners-container">
            {partners.map((partner, index) => (
              <div key={`${partner.id}-${index}`} className="partner-logo">
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>

        <OpenHoursSimple />
      </div>
      <AlertsBar />
    </div>
  );
};

export default BergEventLED;
